module.exports = __webpack_public_path__ + "static/img/join_13.a1cf295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join_13.png
// module id = UtIL
// module chunks = 0